module.exports = __webpack_public_path__ + "static/media/lo5d_post_B.2eb3ab0a.png";